function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient",
  x2: 1.037,
  y2: 1.356,
  gradientUnits: "objectBoundingBox"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#ff3067"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#a5119f"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-2",
  x1: 0.5,
  x2: 0.5,
  y2: 1,
  gradientUnits: "objectBoundingBox"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#fffcfd"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#ff80a2"
})));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Group_5007",
  "data-name": "Group 5007",
  transform: "translate(-706 -411)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_4756",
  "data-name": "Group 4756",
  transform: "translate(706 411)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_4701",
  "data-name": "Group 4701"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_36",
  "data-name": "Rectangle 36",
  width: 76,
  height: 76,
  rx: 7,
  fill: "url(#linear-gradient)"
}))), /*#__PURE__*/React.createElement("g", {
  id: "Group_4749",
  "data-name": "Group 4749",
  transform: "translate(717.31 473.079)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_4750",
  "data-name": "Group 4750"
}, /*#__PURE__*/React.createElement("circle", {
  id: "Ellipse_15",
  "data-name": "Ellipse 15",
  cx: 2.089,
  cy: 2.089,
  r: 2.089,
  fill: "#fff9fb"
})), /*#__PURE__*/React.createElement("g", {
  id: "Group_4751",
  "data-name": "Group 4751",
  transform: "translate(7.383)"
}, /*#__PURE__*/React.createElement("circle", {
  id: "Ellipse_16",
  "data-name": "Ellipse 16",
  cx: 2.089,
  cy: 2.089,
  r: 2.089,
  fill: "#fff9fb"
})), /*#__PURE__*/React.createElement("g", {
  id: "Group_4752",
  "data-name": "Group 4752",
  transform: "translate(14.765)"
}, /*#__PURE__*/React.createElement("circle", {
  id: "Ellipse_17",
  "data-name": "Ellipse 17",
  cx: 2.089,
  cy: 2.089,
  r: 2.089,
  fill: "#fff9fb"
}))), /*#__PURE__*/React.createElement("g", {
  id: "Group_4755",
  "data-name": "Group 4755",
  transform: "translate(717.112 420.77)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_4750-2",
  "data-name": "Group 4750",
  transform: "translate(25.305 0)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_3556",
  "data-name": "Path 3556",
  d: "M239.559,42.808H233.1a1.492,1.492,0,0,1,0-2.983h6.462a1.492,1.492,0,0,1,0,2.983Z",
  transform: "translate(-231.605 -39.825)",
  fill: "#fff9fb"
})), /*#__PURE__*/React.createElement("g", {
  id: "Group_4751-2",
  "data-name": "Group 4751",
  transform: "translate(0 0)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_3557",
  "data-name": "Path 3557",
  d: "M123.55,42.808H105.9a1.492,1.492,0,1,1,0-2.983h17.65a1.492,1.492,0,1,1,0,2.983Z",
  transform: "translate(-104.409 -39.825)",
  fill: "#fff9fb"
}))), /*#__PURE__*/React.createElement("g", {
  id: "Group_4754",
  "data-name": "Group 4754",
  transform: "translate(717.219 429.454)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_4748",
  "data-name": "Group 4748",
  transform: "translate(0 0)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_3555",
  "data-name": "Path 3555",
  d: "M157.309,125.943h-2.042L123.6,123.627l-18.2-14V88.277a1.865,1.865,0,0,1,1.961-1.75h49.944a1.865,1.865,0,0,1,1.961,1.75v35.915A1.865,1.865,0,0,1,157.309,125.943Z",
  transform: "translate(-105.404 -86.527)",
  fill: "url(#linear-gradient-2)"
})), /*#__PURE__*/React.createElement("g", {
  id: "Group_4752-2",
  "data-name": "Group 4752",
  transform: "translate(0 15.256)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_3558",
  "data-name": "Path 3558",
  d: "M107.379,197.849h48.316l-18.907-16.732a2.163,2.163,0,0,0-2.8,0l-4.148,3.67a1.081,1.081,0,0,1-1.4,0L116.483,174.2a2.163,2.163,0,0,0-2.8,0l-8.285,7.332V196.1A1.874,1.874,0,0,0,107.379,197.849Z",
  transform: "translate(-105.402 -173.689)",
  fill: "#fc2f69"
})), /*#__PURE__*/React.createElement("g", {
  id: "Group_4753",
  "data-name": "Group 4753",
  transform: "translate(36.267 9.11)"
}, /*#__PURE__*/React.createElement("circle", {
  id: "Ellipse_18",
  "data-name": "Ellipse 18",
  cx: 3.335,
  cy: 3.335,
  r: 3.335,
  fill: "#fc2f69"
}))));

function SvgUnactivePostIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnactivePostIcon);
export default __webpack_public_path__ + "static/media/unactive-post-icon.ff3d55a6.svg";
export { ForwardRef as ReactComponent };